import { EntriEvents } from '@wix/domains-serverless-interface';
const DEFAULT_TIMEOUT_MS = 3000;

/**
 * Resolves once Entri has actually closed, i.e. once it dispatched
 * `onEntriClose`. `window.entri.close()` alone does not tell us this — the flow
 * promise in `startEntriClient` only settles (and its listeners only dispose)
 * on that event, so callers that tear down the embed container or navigate away
 * beforehand leave the flow hanging forever.
 *
 * Bounded by a timeout so a misbehaving Entri can never wedge navigation.
 */
export const waitForEntriClose = function (timeoutMs) {
  if (timeoutMs === void 0) {
    timeoutMs = DEFAULT_TIMEOUT_MS;
  }
  return new Promise(resolve => {
    const cleanup = () => {
      clearTimeout(timeoutId);
      window.removeEventListener(EntriEvents.onEntriClose, handler);
    };
    const handler = () => {
      cleanup();
      resolve();
    };
    window.addEventListener(EntriEvents.onEntriClose, handler);
    const timeoutId = setTimeout(() => {
      cleanup();
      resolve();
    }, timeoutMs);
  });
};
//# sourceMappingURL=waitForEntriClose.js.map